import React, { useRef, useState, useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Producers from "./components/Producers";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  // Refs do sekcji
  const heroRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const contactRef = useRef(null);

  const [activeSection, setActiveSection] = useState("hero");

  // 🔹 Funkcja przewijania
  const scrollToSection = (section) => {
    if (section === "hero") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const sectionRef =
        section === "about"
        ? aboutRef
        : section === "services"
        ? servicesRef
        : section === "contact"
        ? contactRef
        : null;

    if (sectionRef && sectionRef.current) {
      const element = sectionRef.current;
      const elementRect = element.getBoundingClientRect();
      const scrollTop =
        window.pageYOffset +
        elementRect.top -
        window.innerHeight / 2 +
        elementRect.height / 2;

      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });
    }
  };

  // 🔹 Podświetlanie aktywnej sekcji w nav
  useEffect(() => {
    const sections = [
      { name: "hero", ref: heroRef },
      { name: "about", ref: aboutRef },
      { name: "services", ref: servicesRef },
      { name: "contact", ref: contactRef },
    ];

    const handleScroll = () => {
      const scrollPos = window.scrollY + window.innerHeight / 2;
      for (const section of sections) {
        if (
          section.ref.current.offsetTop <= scrollPos &&
          section.ref.current.offsetTop +
            section.ref.current.offsetHeight >
            scrollPos
        ) {
          setActiveSection(section.name);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Header scrollToSection={scrollToSection} activeSection={activeSection} />
      <main>
        <section ref={heroRef} id="hero">
          <Hero />
        </section>
        <section id="producenci">
          <Producers />
        </section>
        <section ref={aboutRef} id="about">
          <About />
        </section>
        <section ref={servicesRef} id="services">
          <Services />
        </section>
        <section ref={contactRef} id="contact">
          <Contact />
        </section>
      </main>
      <Footer />
    </>
  );
}

export default App;
